module.exports = __webpack_public_path__ + "img/menu_btn.a81f1707.png";